<template>
    <PainelGrafico
        titulo="Clientes Conquistados"
        v-model:aberto="mostrarGrafico"
        :carregando="carregando"
        :vazio="!carregando && !temDados"
        :dica="mes == null ? 'Clique em um mês para ver as semanas' : ''"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 23rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Soma das oportunidades conquistadas por tipo
                        (novo, recorrente e reciclado).<br>
                        <b>Polaridade:</b> Quanto maior, melhor.<br>
                        <b>Fonte:</b> OMIE > Oportunidades.<br>
                        <b>Descrição:</b> Clientes conquistados classificados por tipo de proposta.
                    </div>
                </v-card>
            </v-menu>
        </template>

        <Bar
            :options="dadosGrafico().options"
            :data="dadosGrafico().data"
            ref="barChart"
        />
    </PainelGrafico>
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import PainelGrafico from '@/components/PainelGrafico.vue';
import { getChartTheme, baseChartOptions } from '@/utils/chartTheme';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'GraficoClientesConquistados',
    components: { Bar, PainelGrafico },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            data: null,
            mostrarGrafico: true,
            carregando: true,
        };
    },
    computed: {
        temDados() {
            return Boolean(this.data?.cliente_novo?.length);
        },
    },
    watch: {
        mes: 'getDados',
        ano: 'getDados',
    },
    mounted() {
        this.getDados();
    },
    methods: {
        async getDados() {
            this.carregando = true;
            try {
                this.data = await serviceGraficos.getClientes(this.mes, this.ano);
            } catch (error) {
                console.error('Erro ao obter clientes:', error);
                this.data = null;
            } finally {
                this.carregando = false;
            }
        },
        dadosGrafico() {
            const theme = getChartTheme();
            const options = baseChartOptions({
                ...theme,
                onClick: (e) => {
                    if (this.mes != null || !this.$refs.barChart?.chart) return;
                    const canvasPosition = getRelativePosition(e, this.$refs.barChart.chart);
                    const dataX = this.$refs.barChart.chart.scales.x.getValueForPixel(canvasPosition.x);
                    if (dataX != null && dataX >= 0) {
                        this.$emit('updateMes', dataX + 1);
                    }
                },
            });

            return {
                data: {
                    datasets: [
                        {
                            label: 'Clientes novos',
                            backgroundColor: '#3571CD',
                            borderRadius: 4,
                            data: this.data?.cliente_novo || [],
                        },
                        {
                            label: 'Clientes recorrentes',
                            backgroundColor: '#1d467b',
                            borderRadius: 4,
                            data: this.data?.cliente_recorrente || [],
                        },
                        {
                            label: 'Clientes reciclados',
                            backgroundColor: '#00b4fc',
                            borderRadius: 4,
                            data: this.data?.cliente_reciclado || [],
                        },
                    ],
                },
                options,
            };
        },
    },
};
</script>
